<template>
  <div class="speaker">
    <div class="speaker-name wolfgang-kaleck-name">Wolfgang Kaleck</div>
    <div class="org-name">ECCHR</div>
    <div class="speaker-avatar">
      <img
        class="speaker-avatar-image wolfgang-kaleck-avatar"
        :src="require('../assets/speaker-avatar/' + 'Wolfgang Kaleck' + '.png')"
        alt="speaker portrait"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.speaker {
  grid-gap: 2px;
  background-color: rgba(58, 58, 60, 1);
  border-radius: 8px;
  display: grid;
  grid-template-columns: 80% 20%;
  grid-template-rows: 30px 30px;
  margin-top: 20px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 15px;
  padding: 10px 25px 10px 25px;
}

.speaker-name {
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 2;
  font-weight: 700;
  font-size: 16px;
  align-self: flex-end;
}
.org-name {
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 2;
  grid-row-end: 3;
  font-weight: 400;
  font-size: 16px;
}

.speaker-avatar {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
}

.speaker-avatar-image {
  border-radius: 50%;
  border-width: 3px;
  border-style: solid;
}

.speaker-avatar > .speaker-avatar-image {
  align-items: center;
  max-width: 100%;
  max-height: 100%;
}
</style>